export const Offline_Online = [
    {
     "BothOffline_OnlineCity": "Patna"
    },
    {
     "BothOffline_OnlineCity": "Delhi"
    },
    {
     "BothOffline_OnlineCity": "Kukatpally"
    },
    {
     "BothOffline_OnlineCity": "Mehdipatnam"
    },
    {
     "BothOffline_OnlineCity": "Ballari"
    },
    {
     "BothOffline_OnlineCity": "Bengaluru"
    },
    {
     "BothOffline_OnlineCity": "Gangavathi"
    },
    {
     "BothOffline_OnlineCity": "Hospet"
    },
    {
     "BothOffline_OnlineCity": "Hubli"
    },
    {
     "BothOffline_OnlineCity": "Mandya"
    },
    {
     "BothOffline_OnlineCity": "Raichur"
    },
    {
     "BothOffline_OnlineCity": "Sindhanur"
    },
    {
     "BothOffline_OnlineCity": "Bhopal"
    },
    {
     "BothOffline_OnlineCity": "Indore"
    },
    {
     "BothOffline_OnlineCity": "Aurangabad"
    },
    {
     "BothOffline_OnlineCity": "Pune"
    },
    {
     "BothOffline_OnlineCity": "Jaipur"
    },
    {
     "BothOffline_OnlineCity": "Chennai"
    },
    {
     "BothOffline_OnlineCity": "Coimbatore"
    },
    {
     "BothOffline_OnlineCity": "Erode"
    },
    {
     "BothOffline_OnlineCity": "Hosur"
    },
    {
     "BothOffline_OnlineCity": "Karur"
    },
    {
     "BothOffline_OnlineCity": "Namakkal"
    },
    {
     "BothOffline_OnlineCity": "Salem"
    },
    {
     "BothOffline_OnlineCity": "Tiruppur"
    },
    {
     "BothOffline_OnlineCity": "Trichy"
    },
    {
     "BothOffline_OnlineCity": "Velachery"
    },
    {
     "BothOffline_OnlineCity": "Agra"
    },
    {
     "BothOffline_OnlineCity": "Firozabad"
    },
    {
     "BothOffline_OnlineCity": "Lucknow"
    },
    {
     "BothOffline_OnlineCity": "Meerut"
    },
    {
     "BothOffline_OnlineCity": "Muzaffarnagar"
    },
    {
     "BothOffline_OnlineCity": "Kolkata"
    }
   ]